<template>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th colspan="3">Task</th>
        <th>Result</th>
        <th>Date</th>
        <th>Instructor</th>
        <th class="u-text-left u-hide-mobile" colspan="2">
          <!-- Aircraft, status, etc. -->
          Details
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="records.length == 0">
        <td colspan="9">
          <no-results-found
            title="No Results Found"
            message="Maybe change the search and filters and try again?"
          ></no-results-found>
        </td>
      </tr>
      <tr
        v-else
        v-for="record in records"
        :key="record.id"
      >
        <td>
          <record-action-button v-bind:record="record"></record-action-button>
        </td>
        <td>{{ record.candidate.full_name }}</td>
        <td style="white-space: nowrap">
          {{ record.task_code }}
        </td>
        <td class="u-text-left">
          {{ record.task_name }}
        </td>
        <td>
          <record-repeat-icon v-bind:isRepeat="record.is_repeat">
          </record-repeat-icon>
        </td>
        <td>
          <div class="tag-container u-left">
            <span>
              <status-tag
                v-if="record.is_closed"
                v-bind:status="record.status"
                v-bind:label="record.result"
                ></status-tag>
              <div class="tag tag--large tag--info" v-if="!record.is_closed">
                Incomplete
              </div>
            </span>
          </div>
        </td>
        <td>{{ formatDate(record.date) }}</td>
        <td>{{ record.instructor }}</td>
        <td class="u-hide-mobile">
          {{ record.aircraft_identifier }}
          <span v-if="record.aircraft_type">
            ({{ record.aircraft_type }})
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<style>
table td.u-text-left,
table th.u-text-left {
  text-align: left !important;
}
td button {
  margin-bottom: 0;
}
</style>
<script>
import { mapGetters } from "vuex";
import { DateFormatter } from "@/functions/dateFormat.function";
import RecordRepeatIcon from "@/components/records/RecordRepeatIcon";
import StatusTag from "@/components/StatusTag";
import RecordActionButton from "@/components/records/RecordActionButton";
import NoResultsFound from "@/components/PlaceholderNoResults";

export default {
  name: "record-table",
  components: {
    RecordRepeatIcon,
    StatusTag,
    NoResultsFound,
    RecordActionButton
  },
  props: {
    error: {},
    records: Array
  },
  computed: {
    ...mapGetters("core", ["userProfile"])
  },
  methods: {
    formatDate: function(dateString) {
      var result = DateFormatter(dateString);
      return result;
    }
  }
};
</script>
